<template>
    <b-modal ref="auctionBidModal" id="auctionBidModal" :title="$t('home.auction_bid_title')" scrollable title-class="text-center" body-class="p-0" centered @hide="hide();" @close="btnSfx">
        <template v-if="auction.type === 'LOWEST_UNIQUE'">
            <div class="text-center pt-4 pl-4 pr-4">
                <h3>{{ $t('home.auction_lu_bid_label') }}</h3>
                <p>{{ $t('home.auction_lu_bid_description') }}</p>
                <div class="mb-4 px-5">
                    <b-input size="lg" v-model="bidInput" type="number" class="text-center"/>
                </div> 
                <div>
                    <b-button variant="primary" @click="submitLowestUnique();btnSfx()" size="lg">{{ $t('home.auction_lu_bid_btn_submit') }}</b-button>
                </div>
            </div>
        </template>
        <template v-else>
            <div v-if="!!auction.id" class="bidHeader row m-0 p-4">
                <div class="col-4">
                    <img src="/images/home/auctions/bid.png"/>
                </div>
                <div class="col-8 d-flex flex-column justify-content-center">
                    <h4 class="mb-3">{{ $t('home.auction_item_label_offer_'+(!!auction.highestPrice ? 'current' : 'start')) }}</h4>
                    <h3>{{ !!auction.highestPrice ? auction.highestPrice.toLocaleString('sr-RS') : auction.startPrice.toLocaleString('sr-RS') }} <img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'"/></h3> 
                </div>
            </div>

            <ul v-if="!!auction.currentBidOptions">
                <li v-for="bid in auction.currentBidOptions" :key="bid">
                    <b-button @click="setBid(bid)" block variant="primary">
                        {{ bid.toLocaleString('sr-RS') }} <img class="diamond" :src="user.mtsCustomer ? '/images/rubins.png' : '/images/diamond.png'"/>
                    </b-button>
                </li>
            </ul>
        </template>

        <template #modal-footer>
            <b-button variant="link" @click="hide();btnSfx()" class="text-orange" size="lg">{{ $t('base.btn_cancel') }}</b-button>
         </template>

    </b-modal>
</template>
<script>
import Vue from 'vue'

import api from '../../api'
import io from '../../socketio';

const AuctionBidPopup = Vue.component('auction-bid-popup', {
    data() {
        return {
            auction: {},
            bidInProcess: false,
            bidInput: ""
        }
    },

    computed:{
        user() {
            return this.$store.state.auth.user;
        },
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(auction) {
            this.bidInput = "";
            this.auction = auction;
            this.$refs.auctionBidModal.show();
            io.io.on('AUCTION_UPDATE', this.onAuctionUpdate);
            io.io.on('AUCTION_BID_OUTCOME', this.onAuctionBidOutcome);
        },

        onAuctionUpdate(data){
            if(!!data.id && data.id === this.auction.id){
                this.auction = data;
                let loader = document.getElementById('loader');
                loader.classList.remove("show");
                if(this.bidInProcess){
                    this.hide();
                }
            }
        },

        onAuctionBidOutcome(data){
            if(!!data.id && data.id === this.auction.id){
                this.hide();
            }
        },

        hide() {
            io.io.off('AUCTION_UPDATE', this.onAuctionUpdate);
            io.io.off('AUCTION_BID_OUTCOME', this.onAuctionBidOutcome);
            this.$refs.auctionBidModal.hide();
            let loader = document.getElementById('loader');
            loader.classList.remove("show");
            this.auction = {};
            this.bidInProcess = false;
        },

        setBid(value){
            if(!this.auction.currentBidOptions.includes(value) || this.bidInProcess) 
                return

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show"); 

            this.bidInProcess = true;

            api.auctionsCreateBid(this.auction.id, value)
            .then(res => {
               // show loader and wait for socket io event
               loader.classList.add("show"); 
            }).catch(err => {
                $this.bidInProcess = false;
                api.baseErrorHendler(err);
                loader.classList.remove("show");
            });
        },  

        submitLowestUnique(){
            if(!this.bidInput || !/^\d+(\d+)?$/.test(this.bidInput))
                return;

            let loader = document.getElementById('loader');
            const $this = this;

            this.$bvModal.msgBoxConfirm(this.$t('home.auction_lu_bid_confirm_popup_text'), {
                title: this.$t('home.auction_lu_bid_confirm_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_yes'),
                cancelTitle: this.$t('base.btn_no'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    $this.bidInProcess = true;
                    loader.classList.add("show"); 
                    api.auctionsCreateBid($this.auction.id, parseInt(this.bidInput)).then(res => {
                        loader.classList.add("show"); 
                    })
                    .catch(err => {
                        loader.classList.remove("show");
                        api.baseErrorHendler(err);
                        $this.bidInProcess = false;
                        $this.hide();
                    });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        }
    }
})

export default AuctionBidPopup
</script>